/* eslint-disable import/no-extraneous-dependencies */
// @ts-check
import {
  LEASE_ADMIN,
  LEASE_DASHBOARD,
  LEASE_LOGIN,
  LEASE_MAGIC_LINK,
  LEASE_MISSING_SUBDOMAIN,
  LEASE_PROJECTS,
  LEASE_ROOT,
  LEASE_SETTINGS,
  BUILDING_DETAIL_PAGE,
  LEASE_RESET_PASSWORD,
  LEASE_CREATE_PASSWORD,
  DATABASES_BUILDING_DETAIL_PAGE,
} from '~/legacy/consts'
import MissingSubdomain from './404/MissingSubdomain'
import Account from './Account/Account'
import Admin from './Admin'
import Login from './Login/Login'
import MagicLink from './MagicLink/MagicLink'
import Surveys from './Surveys/Surveys'
import BuildingDetailPage from './Buildings/BuildingDetailPage'
import ResetPassword from './Login/ResetPassword'
import CreatePassword from './Login/CreatePassword'
import SurveyImportPage from '~/legacy/pages/Surveys/Survey/import'

export { Surveys }

const routes = {
  home: {
    path: LEASE_ROOT,
    isPublic: true,
    component: Login,
    exact: true,
    allowMobile: true,
    trackingPageViewName: 'View Homepage',
  },
  dashboard: {
    path: LEASE_DASHBOARD,
    component: Surveys,
    exact: true,
    allowMobile: true,
    trackingPageViewName: 'View Dashboard',
  },
  surveyImport: {
    path: `${LEASE_PROJECTS}/:id/import`,
    component: SurveyImportPage,
    exact: true,
    trackingPageViewName: 'Import Survey',
  },
  datbaseImport: {
    path: `/databases/:id/import`,
    component: SurveyImportPage,
    exact: true,
    trackingPageViewName: 'Import Database',
  },
  projects: {
    path: LEASE_PROJECTS,
    component: Surveys,
    exact: true,
    trackingPageViewName: 'View Surveys',
  },
  settings: {
    path: LEASE_SETTINGS,
    component: Account,
    exact: true,
    trackingPageViewName: 'View Account',
  },
  login: {
    path: LEASE_LOGIN,
    component: Login,
    isPublic: true,
    exact: true,
    allowMobile: true,
    trackingPageViewName: 'View Login',
  },
  resetPassword: {
    path: LEASE_RESET_PASSWORD,
    component: ResetPassword,
    exact: true,
  },
  createPassword: {
    path: LEASE_CREATE_PASSWORD,
    component: CreatePassword,
    exact: true,
  },
  magicLink: {
    path: LEASE_MAGIC_LINK,
    component: MagicLink,
    isPublic: true,
    isRedirect: true,
    exact: true,
    allowMobile: true,
    trackingPageViewName: 'View Magic Link',
  },
  missingSubdomain: {
    path: LEASE_MISSING_SUBDOMAIN,
    component: MissingSubdomain,
    isPublic: true,
    exact: true,
    allowMobile: true,
    skipLoginRedirect: true,
    trackingPageViewName: 'View Missing Subdomain',
  },
  admin: {
    path: LEASE_ADMIN,
    component: Admin,
    exact: true,
    isPublic: false,
    requireAdmin: true,
    trackingPageViewName: 'Admin',
  },
  buildingDetailPage: {
    path: BUILDING_DETAIL_PAGE,
    component: BuildingDetailPage,
    allowAnonymous: true,
    allowMobile: true,
    trackingPageViewName: 'Building Detail Page',
  },
  databasesBuildingDetailPage: {
    path: DATABASES_BUILDING_DETAIL_PAGE,
    component: BuildingDetailPage,
    allowAnonymous: true,
    allowMobile: true,
    trackingPageViewName: 'Building Detail Page',
  },
}

export default routes
